import React, { useState } from "react";
import { Form, Button } from "antd-mobile";

const Login: React.FC = () => {
  const [phone, setPhone] = useState("");
  const [code, setCode] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [sending, setSending] = useState(false);
  const [countdown, setCountdown] = useState(0);

  const handleSendCode = () => {
    setError("");
    if (!phone || !/^1\d{10}$/.test(phone)) {
      setError("请输入有效的手机号");
      return;
    }
    setSending(true);
    setCountdown(60);
    // 模拟发送验证码
    setTimeout(() => {
      setSending(false);
      alert("验证码已发送");
    }, 1000);
    // 倒计时
    const timer = setInterval(() => {
      setCountdown(prev => {
        if (prev <= 1) {
          clearInterval(timer);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    if (!phone || !/^1\d{10}$/.test(phone)) {
      setError("请输入有效的手机号");
      return;
    }
    if (!code) {
      setError("请输入验证码");
      return;
    }
    setLoading(true);
    // 模拟登录请求
    setTimeout(() => {
      setLoading(false);
      if (phone === "13800138000" && code === "123456") {
        alert("登录成功");
      } else {
        setError("手机号或验证码错误");
      }
    }, 1000);
  };

  return null

  // return (
  //   <Container className="flex items-center justify-center min-h-screen bg-gray-100">
  //     <Row className="w-full max-w-md mx-auto">
  //       <Col>
  //         <div className="bg-white p-8 rounded shadow-md">
  //           <h2 className="text-2xl font-bold mb-6 text-center">手机号验证码登录</h2>
  //           {error && <Alert variant="danger">{error}</Alert>}
  //           <Form onSubmit={handleSubmit}>
  //             <Form.Group className="mb-4" controlId="formPhone">
  //               <Form.Label>手机号</Form.Label>
  //               <Form.Control
  //                 type="text"
  //                 placeholder="请输入手机号"
  //                 value={phone}
  //                 onChange={e => setPhone(e.target.value)}
  //                 className="focus:ring-2 focus:ring-blue-500"
  //                 maxLength={11}
  //               />
  //             </Form.Group>
  //             <Form.Group className="mb-6" controlId="formCode">
  //               <Form.Label>验证码</Form.Label>
  //               <div className="flex">
  //                 <Form.Control
  //                   type="text"
  //                   placeholder="请输入验证码"
  //                   value={code}
  //                   onChange={e => setCode(e.target.value)}
  //                   className="focus:ring-2 focus:ring-blue-500 mr-2"
  //                   maxLength={6}
  //                 />
  //                 <Button
  //                   variant="outline-primary"
  //                   onClick={handleSendCode}
  //                   disabled={sending || countdown > 0}
  //                   style={{ minWidth: 120 }}
  //                 >
  //                   {countdown > 0 ? `重新发送(${countdown}s)` : "发送验证码"}
  //                 </Button>
  //               </div>
  //             </Form.Group>
  //             <Button
  //               variant="primary"
  //               type="submit"
  //               className="w-full py-2 text-lg bg-blue-600 hover:bg-blue-700 border-0"
  //               disabled={loading}
  //             >
  //               {loading ? "登录中..." : "登录/注册"}
  //             </Button>
  //           </Form>
  //         </div>
  //       </Col>
  //     </Row>
  //   </Container>
  // );
};

export default Login;
